export interface Job {
  id: string;
  name: string;
};

const jobs: Array<Job> = [
  {
    id: '1',
    name: 'Javaエンジニア募集',
  },
  {
    id: '2',
    name: '組み込みエンジニア募集',
  },
  {
    id: '3',
    name: 'フロントエンドエンジニア募集',
  },
  {
    id: '4',
    name: 'iOSエンジニア募集',
  },
  {
    id: '5',
    name: 'Androidエンジニア募集',
  },
  {
    id: '6',
    name: 'データサイエンティスト募集',
  },
];

export default jobs;
